import { Box, Button, Center } from '@mantine/core';
import { IconCalendarEvent, IconFiles, IconInbox } from '@tabler/icons';
import { FC, useContext } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import NavigationLink from '../../../Atoms/Navigation/NavigationLink';
import { useNavigationItem } from '../../../Organismns/Navigation/NavigationItemHook';
import { WindowContext } from '../../../Service/Context/WindowContext';
import { TestS } from '../../../TestS';
import EmailBoxCounter from '../../Emails/EmailBoxCounter';
import { useContactDetails } from '../../../Service/Context/ContactDetailsContext';
import ContactTile from './ContactTile';
import { useBookitupScope } from '../../../Service/Context/BookitupSubscriptionContext';

const ContactNavBar: FC<{ closeNavBar?: () => void }> = ({ closeNavBar }) => {
  const { id: contactId } = useParams();
  const { removeContact, unreadMessagesProps } = useContactDetails();
  const { unreadCount } = unreadMessagesProps;
  const navigate = useNavigate();
  const { sm } = useContext(WindowContext);
  const { isScopeSelected: hasDocumentsScope } = useBookitupScope('DOCUMENTS');
  const { isScopeSelected: hasEmailScope } = useBookitupScope('EMAILS');
  const documentsItemActive = useNavigationItem(`/contacts/${contactId}/documents`);
  const inboxItemActive = useNavigationItem(`/contacts/${contactId}/emails/inbox`);
  const draftsItemActive = useNavigationItem(`/contacts/${contactId}/emails/drafts`);
  const scheduledItemActive = useNavigationItem(`/contacts/${contactId}/emails/scheduled`);
  const failedItemActive = useNavigationItem(`/contacts/${contactId}/emails/failed`);
  const outboundItemActive = useNavigationItem(`/contacts/${contactId}/emails/outbound`);
  const trashItemActive = useNavigationItem(`/contacts/${contactId}/emails/trash`);

  // eslint-disable-next-line no-underscore-dangle
  const _onClick = (path: string) => {
    navigate(path);
    if (closeNavBar) closeNavBar();
  };

  return (
    <>
      {!sm && (
        <Box p="md">
          <ContactTile />
        </Box>
      )}
      <NavigationLink
        variant="filled"
        label="Details"
        onClick={() => _onClick(`/contacts/${contactId}/details`)}
        active={useNavigationItem(`/contacts/${contactId}/details`)}
        icon={sm && <IconCalendarEvent size={16} />}
      />
      {hasDocumentsScope && (
        <NavigationLink
          variant="filled"
          label="Dateien"
          onClick={() => _onClick(`/contacts/${contactId}/documents`)}
          active={documentsItemActive}
          icon={sm && <IconFiles size={16} />}
          testId={TestS.Events.Navigate.TO_DOCUMENTS}
        />
      )}
      {hasEmailScope && (
        <NavigationLink defaultOpened label="E-Mails" icon={sm && <IconInbox size={16} />} childrenOffset={28}>
          <NavigationLink
            label="Posteingang"
            active={inboxItemActive}
            onClick={() => _onClick(`/contacts/${contactId}/emails/inbox`)}
            variant="filled"
            rightSection={<EmailBoxCounter count={unreadCount} />}
          />
          <NavigationLink
            label="Entwürfe"
            active={draftsItemActive}
            onClick={() => _onClick(`/contacts/${contactId}/emails/drafts`)}
            variant="filled"

          />
          <NavigationLink
            label="Geplant"
            active={scheduledItemActive}
            onClick={() => _onClick(`/contacts/${contactId}/emails/scheduled`)}
            variant="filled"

          />
          <NavigationLink
            label="Fehlgeschlagen"
            active={failedItemActive}
            onClick={() => _onClick(`/contacts/${contactId}/emails/failed`)}
            variant="filled"
            //rightSection={<EmailBoxCounter count={failedCount} />}
          />
          <NavigationLink
            label="Gesendet"
            active={outboundItemActive}
            onClick={() => _onClick(`/contacts/${contactId}/emails/outbound`)}
            variant="filled"
          />
          <NavigationLink
            label="Papierkorb"
            active={trashItemActive}
            onClick={() => _onClick(`/contacts/${contactId}/emails/trash`)}
            variant="filled"

          />
        </NavigationLink>
      )}

      <Center>
        <Box sx={{ position: 'absolute', bottom: 20 }}>
          <Button
            color="red"
            variant="subtle"
            onClick={() => {
              if (closeNavBar) closeNavBar();
              removeContact();
            }}
          >
            Kontakt löschen
          </Button>
        </Box>
      </Center>
    </>
  );
};

export default ContactNavBar;
